import * as React from "react";
const SvgShopify = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Shopify_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#000",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95BF47",
  d: "M11.447 3.553c.09 0 .18.026.27.09-.656.31-1.376 1.093-1.672 2.662-.437.142-.862.27-1.26.385.347-1.19 1.183-3.13 2.662-3.13zm.823 1.966v.09c-.502.155-1.055.323-1.596.491.311-1.185.889-1.763 1.39-1.98.129.333.206.783.206 1.4m.36-1.489c.462.05.76.578.952 1.17-.232.076-.49.154-.772.244v-.168c0-.501-.064-.914-.18-1.247zm1.994.86c-.013 0-.04.013-.052.013s-.192.05-.476.14c-.282-.822-.784-1.58-1.672-1.58h-.076C12.09 3.14 11.78 3 11.51 3 9.44 3 8.45 5.585 8.14 6.897c-.796.244-1.375.424-1.44.45-.45.142-.462.154-.514.58-.05.308-1.22 9.375-1.22 9.375L14.006 19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.807 10.537s-.54-.283-1.183-.283c-.964 0-1.002.604-1.002.76 0 .822 2.16 1.144 2.16 3.087 0 1.53-.96 2.506-2.271 2.506-1.57 0-2.36-.976-2.36-.976l.43-1.391s.83.71 1.52.71a.63.63 0 0 0 .65-.62c0-1.08-1.769-1.13-1.769-2.907C7.96 9.932 9.03 8.48 11.2 8.48c.838 0 1.25.241 1.25.241l-.63 1.81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5E8E3F",
  d: "m14.225 18.986 4.81-1.04S17.3 6.202 17.286 6.125a.15.15 0 0 0-.14-.129c-.065 0-1.286-.09-1.286-.09s-.85-.85-.96-.941C14.87 4.941 14.8 5 14.8 5l-.59 13.986z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Shopify_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgShopify;
//# sourceMappingURL=Shopify.js.map